/** Origin MS.QuyTrinh (không có `/api`) — dùng axios dev gọi thẳng khi bật NEXT_PUBLIC_*. */
export const resolveQtApiOrigin = (): string => {
  const raw =
    process.env.NEXT_PUBLIC_QT_API_ORIGIN?.trim() ||
    process.env.NEXT_PUBLIC_QT_API_BASE_URL?.trim() ||
    process.env.CONFIG_NEXT_PUBLIC_QT_API_BASE_URL?.trim() ||
    '';
  if (raw) {
    return raw.replace(/\/$/, '').replace(/\/api$/i, '');
  }
  return '';
};

export const isQuyTrinhApiPath = (url: string | undefined): boolean => {
  if (!url) return false;
  const path = url.startsWith('http') ? new URL(url, 'http://local').pathname : url;
  return /^\/v1\/(quytrinh|masterprocess)\b/i.test(path);
};
